import type { ThemeColorType } from '@capsule/consumer-design-system';

import { Link } from 'react-router-dom';
import styled from 'styled-components';
import InlineSVG from 'svg-inline-react';

export const StyledArrow = styled(InlineSVG)<{ color?: ThemeColorType }>`
  height: 1.75rem;
  width: 1.75rem;
  svg {
    line-height: 1.75rem;
    height: 1.75rem;
    width: 1.75rem;
    transform: rotate(-90deg);
    path {
      fill: ${props => (props.color ? props.theme.colors[props.color] : props.theme.colors.capsuleGreen80)};
    }
  }
`;

export const ShowYourDoctorLink = styled(Link)`
  display: flex;
  flex-direction: row;
  /* justify-content: space-between; */
  align-items: center;
`;
